import PropTypes from 'prop-types';
import React from 'react';
import GeneralModal from '../Modal/GeneralModal/general-modal.js';

const ApproveRejectDialog = ({
	open,
	onClose,
	DialogTitles,
	DialogContents,
	handleActionButton,
	handleCancelButton,
	handleActionFunction
}) => {
	const handleCancel = () => {
		onClose();
	};

	const handleApproveReject = () => {
		handleActionFunction();
	};

	return (
		// <Dialog open={open} PaperProps={{ style: { width: '312px', borderRadius: '8px' } }}>
		//   <DialogTitle>
		//     <div style={{ fontSize: '20px' }}>{DialogTitles}</div>
		//   </DialogTitle>
		//   <DialogContent sx={{ padding: checkBalance && type === 'Approval' ? '0 24px' : null }}>
		//     <div style={{ fontSize: '14px', color: '#646464' }}>{DialogContents}</div>
		//     {checkBalance && type === 'Approval' && (
		//       <div style={{ padding: '10px 0' }}>
		//         <div style={{ fontSize: '14px', color: '#646464' }}>Total Amount</div>
		//         <div style={{ fontSize: '17px' }}>{`₹ ${(+TotalAmount).toLocaleString('en-IN')}`}</div>
		//       </div>
		//     )}
		//     <div style={{ fontSize: '13px', color: 'red' }}>{errorMessage}</div>
		//   </DialogContent>
		//   <DialogActions>
		//     <PrimaryButton
		//       value={handleCancelButton}
		//       onClick={handleCancel}
		//       padding='0'
		//       width='103px'
		//       height='40px'
		//       backgroundColor='transparent'
		//       borderRadius='8px'
		//     />
		//     <PrimaryButton
		//       value={handleActionButton}
		//       onClick={handleApproveReject}
		//       backgroundColor='#B7D423'
		//       padding='0'
		//       textcolor='#000000'
		//       width={width}
		//       height='40px'
		//       borderRadius='8px'
		//       disabled={isActionButtonDisabled}
		//     />
		//   </DialogActions>
		// </Dialog>
		<GeneralModal
			open={open}
			onClose={onClose}
			btn2OnClick={handleApproveReject}
			genText={DialogTitles}
			genTextClassName={'medium1'}
			btn1Text={handleCancelButton}
			btn1OnClick={handleCancel}
			no2btn={false}
			btn2Text={handleActionButton}
		>
			<p className='medium6'>{DialogContents}</p>
		</GeneralModal>
	);
};

export default ApproveRejectDialog;

ApproveRejectDialog.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any,
	DialogTitles: PropTypes.any,
	DialogContents: PropTypes.any,
	handleActionButton: PropTypes.any,
	handleCancelButton: PropTypes.any,
	handleActionFunction: PropTypes.any
};
